import {
  cancelEvent,
  loadCalendarIntegrations,
  loadEvents,
  saveCalendarIntegration,
  submitEvent,
  unlinkCalendarIntegration,
} from "actions/eventsAction";
import {initMentorship, initMentorshipSessions} from "actions/mentorshipAction";
import {concat, get} from 'lodash';
import {connect} from 'react-redux';
import AllEvents from "views/Mentorship/AllEvents";

const mapStateToProps = ({
                           auth: {user},
                           event: {events, eventsLoaded, calendarIntegrations},
                           mentorship: {sessions, partnerDetails},
                         }) => ({
  // From the session rather than from partnerDetails: the page can be opened
  // directly, before the mentorship has been fetched.
  mentorshipId: get(user, 'status.mentorships[0].id'),
  profileId: get(partnerDetails, 'userDetails[0].id'),
  mentorshipGroupId: get(user, 'status.mentorGroup', null),
  events,
  eventsLoaded,
  sessions: concat(sessions.ongoingSessions, sessions.allSessions),
  calendarIntegrations,
});

export default connect(mapStateToProps, {
  initMentorship,
  initMentorshipSessions,
  loadEvents,
  loadCalendarIntegrations,
  submitEvent,
  cancelEvent,
  saveCalendarIntegration,
  unlinkCalendarIntegration,
})(AllEvents);
